import { render, staticRenderFns } from "./changeNumber.vue?vue&type=template&id=2f378f4a&scoped=true&"
import script from "./changeNumber.vue?vue&type=script&lang=js&"
export * from "./changeNumber.vue?vue&type=script&lang=js&"
import style0 from "./changeNumber.vue?vue&type=style&index=0&id=2f378f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f378f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
